import { setCanvasSize } from "helpers/mathFunctions";
import Frame from "../types/FrameType";
import Position from "../types/PositionType";
import { Canvas } from "./Canvas";

export class Sprite {
  private _position: Position;
  private _canvas: Canvas;
  private _image: HTMLImageElement;
  private _frames: Frame;
  private _center: Position;
  private _width: number;
  private _height: number;
  private _scale: number = setCanvasSize().scale;

  constructor(
    position: Position,
    imageSrc: string,
    canvas: Canvas,
    frames: Frame = { maxX: 1, maxY: 1 },
    width: number = 0,
    height: number = 0
  ) {
    this._position = position;
    this._canvas = canvas;
    this._image = new Image();
    this._image.src = imageSrc;
    this._frames = frames;
    this._width = Math.floor(width * this._scale);
    this._height = Math.floor(height * this._scale);
    this._center = {
      x: position.x + this.width / 2,
      y: position.y + this.height / 2,
    };
  }

  public draw(isTower: boolean = false) {
    const { x, y } = this._position;
    const cropSprite = {
      position: {
        x: 0,
        y: 0,
      },
      width: this._image.width / this._frames.maxX,
      height: this._image.height / this._frames.maxY,
    };

    this._canvas.drawImage(
      this._image,
      cropSprite.position.x,
      cropSprite.position.y,
      cropSprite.width,
      cropSprite.height,
      x,
      y - (isTower ? this.height : 0),
      cropSprite.width,
      cropSprite.height
    );
  }

  public get position(): Position {
    return this._position;
  }

  public set position(position: Position) {
    this._position = position;
  }

  public get canvas(): Canvas {
    return this._canvas;
  }

  public get width(): number {
    return this._width;
  }

  public set width(width: number) {
    this._width = width;
  }

  public get height(): number {
    return this._height;
  }

  public set height(height: number) {
    this._height = height;
  }

  public get center(): Position {
    return this._center;
  }

  public set center(center: Position) {
    this._center = center;
  }
}
